<template>
  <section>
    <div class="row">
      <div class="col-12">
        <button v-if="!open"
                @click.prevent="open = !open"
                style="z-index: 9"
                class="open-button-conversation bg-dark shadow">
          {{ getTranslations('expression_1113') }} <span class="badge badge-danger rounded-0 font-weight-light ml-1" style="font-size: .7rem;">beta</span>
        </button>
        <div v-if="open"
             style="width: 300px;
	                  margin: 0 auto;
                    height: 450px;"
             class="chat-popup-conversation animated--grow-in bg-white shadow">

          <!--LIST CONVERSATION-->
          <div class="animated--grow-in" v-if="!show">
            <!--TOP - LIST-->
            <div class="row pl-3 pr-3 m-0 bg-dark justify-content-between align-content-center animated--grow-in"
                 style="height: 50px;">
              <div class="d-flex align-content-center cursor_default">
                <div class="pr-2 d-flex align-items-center dropdown no-arrow"
                     id="statusDropdown"
                     role="button"
                     data-toggle="dropdown"
                     aria-haspopup="true"
                     aria-expanded="false">
                  <i class="bx bxs-circle bx-xs cursor_pointer"
                     :class="`text-${getUserOnlineObject('id', me.data.online_key).color}`"
                     style="font-size: .8rem!important;"></i>
                </div>

                <!--Menu dropdown-->
                <div class="dropdown-menu dropdown-menu_navbar dropdown-menu-left animated--fade-in shadow-sm"
                     style="margin-left: -15px!important;"
                     aria-labelledby="statusDropdown">
                  <div v-for="(status, index) in configs.data.user_online" :key="status.id" v-if="status.id > 0">
                    <span @click.prevent="setUserStatus(status.id)" class="cursor_pointer dropdown-item">
                      <i class="bx bxs-circle bx-xs cursor_pointer pr-2" :class="`text-${status.color}`"
                         style="font-size: .8rem!important;"></i>
                      {{ status.name }}
                    </span>
                    <div class="dropdown-divider"></div>
                  </div>
                </div>

                <!--Nome do usuário-->
                <div>
                  <small class="text-white"
                         style="font-family: 'Product Sans Medium Regular', sans-serif;">
                    {{ me.data.name | truncate(20) }}
                  </small>
                </div>
              </div>
              <div class="d-flex align-content-center">
                <i @click.prevent="open = !open"
                   v-b-tooltip.bottom :title="getTranslations('expression_549')"
                   class="bx bx-sm bx-chevron-down cursor_pointer"></i>
              </div>
            </div>
            <!--CONTENT LIST-->
            <div class="" style="overflow: auto;
                      padding-bottom: 50px;
                      height: calc(100% - 50px);
                      max-height: 450px;">
              <div class="row px-0 m-0">
                <div v-for="(conversation, index) in orderedConversations" :key="index"
                     @click.prevent="set_conversation(conversation)"
                     class="col-12 px-3 d-flex cursor_pointer list_conversation justify-content-between align-content-center">
                  <div class="d-flex align-content-center"
                       v-b-tooltip.bottom
                       :title="conversation.name">
                    <div class="pr-2 d-flex align-items-center ">
                      <i class="bx bxs-user-circle"></i>
                    </div>
                    <div class="d-flex  align-items-center">
                      <small class="">{{ conversation.name | truncate(25) }}</small>
                      <div v-if="conversation.conversations_count > 0" class="text_small_list d-flex">
                        <span class="ml-2 badge" style="background: #e1e1e1; border-radius: 20px; padding: 0.2rem 0.4rem; font-size: 0.5rem;">
                          {{ conversation.conversations_count }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="pl-2 d-flex align-items-center ">
                    <div>
                      <i class="bx bxs-circle cursor_pointer"
                         style="font-size: .8rem!important;"
                         v-b-tooltip.bottom :title="getUserOnlineObject('id', conversation.online_key).name"
                         :class="`text-${getUserOnlineObject('id', conversation.online_key).color}`"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!--SHOW CONVERSATION-->
          <div class="animated--grow-in" v-else>
            <!--TOP - CONVERSATION-->
            <div class="row pl-3 pr-3 m-0 bg-dark justify-content-between align-content-center animated--grow-in"
                 style="height: 50px;">
              <div class="d-flex align-content-center">
                <i @click.prevent="clear_conversation"
                   v-b-tooltip.bottom :title="getTranslations('expression_113')"
                   class="bx bx-sm bx-chevron-left cursor_pointer"></i>
              </div>
              <div class="d-flex align-content-center pr-3 cursor_default">
                <div class="pr-2 d-flex align-items-center ">
                  <i class="bx bxs-circle bx-xs cursor_pointer"
                     v-b-tooltip.bottom :title="getUserOnlineObject('id', user_active.online_key).name"
                     :class="`text-${getUserOnlineObject('id', user_active.online_key).color}`"
                     style="font-size: .8rem!important;"></i>
                </div>
                <div>
                  <small class="text-white"
                         style="font-family: 'Product Sans Medium Regular', sans-serif;">
                    {{ user_active.name | truncate(20) }}
                  </small>
                </div>
              </div>
              <div class="d-flex align-content-center">
                <i @click.prevent="open = !open"
                   v-b-tooltip.bottom :title="getTranslations('expression_549')"
                   class="bx bx-sm bx-chevron-down cursor_pointer"></i>
              </div>
            </div>
            <!--CONTENT CONVERSATION-->
            <div class="conversation animated--grow-in"
                 :style="`height: calc(100% - ${heightWindow}px)!important;`"
                 style="overflow: auto;
                        padding-bottom: 0;
                        margin-bottom: 0;
                        position: absolute;
                        width: 100%;">
              <div class="row px-0 m-0"
                   id="window_conversation">
                <div class="pt-2 pb-3 px-2 w-100">
                  <ChatBalloonConversation v-for="conversation in conversations.chat"
                                           :key="conversation.id"
                                           :history="conversation"
                                           show_reply="y"
                                           class="px-3"/>
                </div>

                <div v-if="conversations.chat.length === 0"
                     style="height: 295px;
                            display: flex;
                            justify-content: center;
                            align-items: center;"
                     class="col-12">
                  <div class="d-block pt-3 text-center">
                    <div class="pt-4">
                      <i class="fas fa-inbox fa-3x pb-1 text-gray-300"></i>
                    </div>
                    <div class="pt-1">
                      <small>{{ getTranslations('expression_1126') }}.</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!--INPUT - EMOJI-->
            <div v-if="isShowEmojiConversation"
                 class="row animated--grow-in px-0 m-0"
                 style="position: absolute;
                          width: 100%;
                          z-index: 9;
                          background: white;
                          height: 100px;
                          bottom: 50px;">
              <div class="w-100 border-top d-flex justify-content-between">
                <VEmojiPicker @select="selectEmojiConversation"
                              :emojiWithBorder="false"
                              :emojisByRow="8"
                              :showSearch="false"
                              :i18n="i18n"
                              :limitFrequently="8"
                              class="custom-picker-emoji shadow animated--fade-in" />
              </div>
            </div>
            <!--REPLY - PREVIEW-->
            <div v-if="isShowReply"
                 class="row animated--grow-in px-0 m-0"
                 style="position: absolute;
                          width: 100%;
                          z-index: 9;
                          background: white;
                          height: 100px;
                          bottom: 50px;">
              <div class="col-12 d-block pb-0 pt-3 pr-0 text-center" style="align-self: center;">
                <div class="d-flex pt-1 px-1 pb-2">
                  <div class="d-flex w-100 my-0"
                       :class="'callout'"
                       style="background: rgb(0 0 0 / 8%);
                            border-radius: 8px;
                            font-size: 12px;
                            padding: 10px;">
                    <div class="pl-1 cursor_default pr-3 w-100">
                      <div class="row">
                        <div class="col-12 pt-3 pb-0 text-left">
                          <strong v-if="me.data.id && conversations.reply && conversations.reply.sender_id" :class="'title-color'">
                            {{ me.data.id === conversations.reply.sender_id ?
                               getTranslations('expression_1096') :
                               user_active.name | truncate(20) }}
                          </strong>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 pt-1 pb-3 cursor_default text-left">
                          <span v-b-tooltip.bottom
                                :title="conversations.reply.text">
                          {{ (conversations.reply.text ? conversations.reply.text : getTranslations('expression_866')) | truncate(30) }}
                        </span>
                        </div>
                      </div>
                    </div>
                    <!-- GENERIC FILES -->
                    <div v-if="conversations.reply.file" style="max-height: 50px;
                              min-height: 50px;
                              min-width: 50px;
                              max-width: 50px;
                              margin-top: 0;
                              display: flex;
                              border-radius: 8px;
                              align-items: center;
                              justify-content: center;"
                         class="bg-light  cursor_pointer reply-img"
                         @click.prevent="openUrl(conversations.reply.file)">
                      <i class="bx bx-file bx-sm text-gray-700"></i>
                    </div>
                  </div>
                  <div @click.stop="clear_conversations_reply()" class="d-flex pr-0 mr-0 cursor-pointer" style="align-items: center;">
                    <i class="bx bx-x animated--grow-in pl-3 pr-1" style="font-size: 1.4rem;"></i>
                  </div>
                </div>
              </div>
            </div>
            <!--INPUT - EMOJI-->
            <div v-if="isShowEmojiConversation"
                 class="row px-0 m-0"
                 style="position: absolute;
                          width: 100%;
                          z-index: 9;
                          background: white;
                          height: 100px;
                          bottom: 50px;">
              <div class="w-100 border-top d-flex justify-content-between">
                <VEmojiPicker @select="selectEmojiConversation"
                              :emojiWithBorder="false"
                              :emojisByRow="8"
                              :showSearch="false"
                              :i18n="i18n"
                              :limitFrequently="8"
                              class="custom-picker-emoji shadow animated--fade-in" />
              </div>
            </div>
            <!--INPUT-->
            <div class="row px-0 m-0"
                 style="position: absolute;
                          width: 100%;
                          z-index: 9;
                          background: white;
                          height: 50px;
                          bottom: 0;">
              <div class="w-100 border-top d-flex justify-content-between">
                <div class="col cursor_pointer text-left" style="align-self: center;">
                  <div class="d-flex">
                    <i v-b-tooltip.top
                       :title="getTranslations('expression_298')"
                       @click.stop="showEmojiConversation"
                       :class="isShowEmojiConversation ? 'bx bx-x' : 'bx bx-happy'"
                       class=" pr-2"></i>
                    <i @click.stop="changeFileConversation" class="bx bx-paperclip pr-1"></i>
                    <input type="file" @change.stop="loadFile" id="fileHandlerConversationNew" hidden>
                    <input type="hidden" v-model="new_msg.upload_file">
                  </div>
                </div>
                <div class="d-flex text-center">
                  <input type="text"
                         v-model="new_msg.text"
                         ref="conversations_msg"
                         id="conversations_msg"
                         @keyup.enter="sendConversation"
                         :placeholder="getTranslations('expression_185')"
                         class="w-100">
                </div>
                <div class="col cursor_pointer text-right"
                     @click.prevent="sendConversation"
                     style="align-self: center;">
                  <i class="bx bx-send"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {mapState} from "vuex";
import ChatBalloonConversation from "./ChatBalloonConversation";
import Swal from "sweetalert2";
import $ from "jquery";
import Push from "push.js";
import lead_avatar from "../../assets/img/no-pic-user.png";
import iziToast from "izitoast";

export default {
  name: "ConversationWindow",
  components: {ChatBalloonConversation},
  data(){
    return {
      lead_avatar: lead_avatar,
      open: false,
      show: false,
      user_active: {
        id: null,
        name: null,
        online_key: null,
      },
      new_msg: {
        id: null,
        conversation_id: null,
        sender_id: null,
        recipient_id: null,
        text: null,
        upload_file: null,
        file: null,
        mime_type_file: null,
        url_file: null,
      },
      startPosition: null,
      endPosition: null,
      isShowEmojiConversation: false,
      isShowReply: false,
      i18n: {
        search: 'Pesquisar...',
        categories: {
          Activity: "Atividades",
          Flags: "Bandeiras",
          Foods: "Comida",
          Frequently: "Frequentes",
          Objects: "Objetos",
          Nature: "Natureza",
          Peoples: "Pessoas",
          Symbols: "Símbolos",
          Places: "Locais"
        }
      },
    }
  },
  computed: {
    ...mapState(['conversations', 'me']),
    orderedConversations() {
      // return this.conversations.data
      // TODO: Removido o trecho '.slice(0, 8)' no final do return abaixo. Por isso só tava exibindo 8 usuários.
      return _.orderBy(this.xeroxHelper(this.conversations.data), ['is_online', 'online_key'], ['desc'])
    },
    heightWindow() {
      if((this.isShowEmojiConversation || this.isShowReply)) {
        return 195
      } else {
        return 95
      }
    }
  },
  mounted() {
    this.$root.$on('setUserStatus',(payload)=> {
      if (payload.id === this.user_active.id) {
        this.user_active.name = payload.name;
        this.user_active.online_key = payload.online_key;
      }
    });
    this.$root.$on('setConversation', conversation => {
      if(conversation.recipient_id === this.me.data.id && this.user_active.id !== conversation.sender_id){
        //Notificações
        setTimeout(() => {
          Push.create(`${this.getUserObject('id', conversation.sender_id).name} ${this.getTranslations('expression_1112')}`, {
            body: `${conversation.url_file ? 'Midia' : conversation.text}`,
            icon: `${this.lead_avatar}`,
            timeout: 20000,
            tag: `message-internal-${conversation.sender_id}`,
            vibrate: [200, 100],
            onClick: () => {
              window.focus();
              // this.close();
              setTimeout(() => {
                this.open = true
                this.set_conversation(this.getUserObject('id', conversation.sender_id))
              }, 100);
            }
          });
          iziToast.show({
            id: `message-internal-${conversation.sender_id}`,
            title: `${this.getUserObject('id', conversation.sender_id).name} ${this.getTranslations('expression_1112')}`,
            message: `${conversation.url_file ? 'Midia' : conversation.text}`,
            // icon: `${this.lead_avatar ? this.lead_avatar : null}`,
            layout: 2,
            theme: 'light',
            maxWidth: 400,
            imageWidth: 100,
            backgroundColor: '#fff',
            displayMode: 'replace',
            drag: true,
            progressBar: false,
            buttons: [
              ['<button>' + this.getTranslations('expression_1110') + '</button>', (instance, toast) => {
                instance.hide({
                  transitionOut: 'fadeOutUp',
                  onClosing: () => {
                    setTimeout(() => {
                      this.open = true
                      this.set_conversation(this.getUserObject('id', conversation.sender_id))
                    }, 100);
                  }
                }, toast);
              }]
            ],
          });
        }, 500);
      }
      if (conversation.deleted_at === null && (conversation.sender_id === this.me.data.id && conversation.recipient_id === this.user_active.id) || (conversation.recipient_id === this.me.data.id && conversation.sender_id === this.user_active.id)) {
        const conversationKey = this.conversations.chat.findIndex(conversationData => {
          return conversationData.id === conversation.id
        })
        if (conversationKey > -1) {
          this.conversations.chat.splice(conversationKey, 1)
        }
        if (conversation.deleted_at === null) {
          this.conversations.chat.push(conversation)
        }
        if (this.show){
          setTimeout(() => {
            document.getElementById('window_conversation').scrollIntoView({block: "end", behavior: "smooth"});
          }, 500);
        }
      }
    })
  },
  watch: {
    'conversations.reply': function () {
      if (this.conversations.reply && this.conversations.reply.sender_id) {
        this.isShowReply = true
      }
      setTimeout(() => {
        document.getElementById('window_conversation').scrollIntoView({block: "end", behavior: "smooth"});
      }, 500);
    }
  },
  methods: {
    openUrl(payload) {
      window.open(payload, "_blank");
    },
    set_conversation(payload){
      if (payload.id) {
        this.$store.dispatch('getConversationsChat', payload)
        this.show = true
        this.user_active = {
          id: payload.id,
          name: payload.name,
          online_key: payload.online_key,
        }
        setTimeout(() => {
          if (this.user_active && this.user_active.id) {
            document.getElementById('window_conversation').scrollIntoView({block: "end", behavior: "smooth"});
          }
        }, 1500);
      }
    },
    clear_conversation(){
      this.show = false
      this.conversations.chat = []
      this.user_active = {
        name: null,
        online_key: null,
      }
      this.isShowEmojiConversation = false
    },
    clear_conversations_reply() {
      this.isShowReply = false;
      this.conversations.reply = null;
    },
    setUserStatus(payload){
      this.$store.dispatch('updateUser', {
        id: this.me.data.id,
        online_key: payload
      })
    },
    sendConversation(){
      if (this.new_msg.text && this.new_msg.text !== '' || this.new_msg.file && this.new_msg.file !== '') {
        this.new_msg.conversation_id = (this.conversations.reply && this.conversations.reply.id) ? this.xeroxHelper(this.conversations.reply.id) : null
        this.new_msg.sender_id = this.me.data.id // ID do usuário logado
        this.new_msg.recipient_id = this.user_active.id // ID do usuário
        this.$store.dispatch('newConversation', this.new_msg)
        this.isShowEmojiConversation = false
        setTimeout(() => {
          document.getElementById('window_conversation').scrollIntoView({block: "end", behavior: "smooth"});
        }, 500);
      }
      // Limpa a mensagem nova
      this.new_msg = {
        id: null,
        conversation_id: null,
        sender_id: null,
        recipient_id: null,
        text: null,
        upload_file: null,
        file: null,
        mime_type_file: null,
        url_file: null,
      }
      this.clear_conversations_reply()
    },
    showEmojiConversation() {
      this.isShowEmojiConversation = !this.isShowEmojiConversation;
      setTimeout(() => {
        document.getElementById('window_conversation').scrollIntoView({block: "end", behavior: "smooth"});
      }, 500);
    },
    selectEmojiConversation(a) {
      this.startPosition = this.$refs.conversations_msg.selectionStart;
      this.endPosition = this.$refs.conversations_msg.selectionEnd;
      this.$refs.conversations_msg.setSelectionRange(this.startPosition, this.endPosition);
      const text = this.$refs.conversations_msg.value;
      if(text === null) {
        this.new_msg.text = a.data
      } else {
        const textBefore = text.substring(0, this.startPosition);
        const textAfter = text.substring(this.endPosition, text.length);
        this.new_msg.text = `${textBefore}${a.data}${textAfter}`
        this.startPosition += a.data.length;
      }
      setTimeout(() => {
        this.$refs.conversations_msg.setSelectionRange(this.startPosition, this.startPosition);
        this.$refs.conversations_msg.focus()
      }, 100)
    },
    loadFile(){
      const files = document.getElementById('fileHandlerConversationNew')
      if(files.files && files.files[0]){
        const file = files.files[0]
        if ([
          'image/png',
          'image/jpeg',
          'image/jpg',
          'application/pdf',
          'video/mpeg',
          'video/mp4',
          'audio/mpeg',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/msword',
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ].includes(file.type)) {
          const size = (file.size / 1024) / 1024
          if (size <= 5) {
            const FR = new FileReader();
            FR.addEventListener('load', (e) => {
              this.new_msg.upload_file = e.target.result
              this.new_msg.url_file = e.target.result
              this.new_msg.file = e.target.result
              this.new_msg.mime_type_file = file.type
            })
            FR.readAsDataURL(file)
            // Faz o envio do arquivo:
            setTimeout(() => {
              this.sendConversation();
            }, 300)
          } else {
            Swal.fire(
              `${ this.getTranslations('expression_683') }`,
              `${this.getTranslations('expression_681')} <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
              'warning'
            )
          }
        } else {
          Swal.fire(
            `${ this.getTranslations('expression_683') }`,
            `${ this.getTranslations('expression_684') } <br/> <small>${this.getTranslations('expression_705')}</small> <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
            'warning'
          )
        }
      }
      files.value = ''
    },
    removeFileReply() {
      this.new_msg.upload_file = null
      this.new_msg.file = null
      this.new_msg.mime_type_file = null
      this.new_msg.url_file = null
    },
    changeFileConversation(){
      $('#fileHandlerConversationNew').click()
    }
  }
}
</script>

<style scoped>
#window_conversation {
  /*height: 242px;*/
  /*position: relative;*/
}
.open-button-conversation {
  background-color: #555;
  color: white;
  padding: 16px 20px;
  border: none;
  cursor: pointer;
  opacity: 1;
  position: fixed;
  bottom: 0;
  left: 24px;
  width: 300px;
}
.chat-popup-conversation {
  position: fixed;
  bottom: 0;
  left: 24px;
  border: 0;
  z-index: 999;
}
.form-container-conversation {
  max-width: 300px;
  padding: 0;
  background-color: white;
}
.form-container-conversation textarea {
  width: 100%;
  padding: 15px;
  margin: 5px 0 22px 0;
  border: none;
  background: #f1f1f1;
  resize: none;
  min-height: 200px;
}
.form-container-conversation textarea:focus {
  background-color: #ddd;
  outline: none;
}
.form-container-conversation .btn {
  background-color: #04AA6D;
  color: white;
  padding: 16px 20px;
  border: none;
  cursor: pointer;
  width: 100%;
  margin-bottom:10px;
  opacity: 0.8;
}
.form-container-conversation .cancel {
  background-color: red;
}
.form-container-conversation .btn:hover, .open-button-conversation:hover {
  opacity: 1;
}
.list_conversation:hover {
  transition: all .2s;
}
.list_conversation:hover {
  background: #f4f4f4;
  color: #5e5e5e;
}
.conversation{
  /*height: calc(100% - 50px);*/
  /*overflow: auto;*/
  /*padding: 20px;*/
  /*padding-bottom: 0;*/
}
</style>
